import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { TextField, Grid, RadioGroup, FormControlLabel, Radio } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Modal from '@material-ui/core/Modal';
import Button from '@material-ui/core/Button';
import APIService from '../services/APIService';
import RestaurantType from '../constants/RestaurantType';
import { withTranslation } from 'react-i18next';

const styles = theme => ({
    paper: {
        position: 'absolute',
        width: theme.spacing.unit * 50,
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing.unit * 4,
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)'
    },
});

class RestaurantAdder extends Component {
    constructor(props) {
        super(props);

        this.state = {
            open: props.open,

            name: '',
            email: '',
            password: '',
            reporting_period_start: '',
            reporting_period_end: '',
            type: 1
        };
    }

    reset() {
        this.setState({
            name: '',
            email: '',
            password: '',
            reporting_period_start: '',
            reporting_period_end: '',
            type: 1
        });
    }

    add() {
        const { name, email, password, reporting_period_start, reporting_period_end, type } = this.state;
        let data = { name, email, password, reporting_period_start, reporting_period_end, type };
        APIService.storeRestaurant(data)
            .then((restaurant) => {
                if (restaurant) {
                    /**
                     * Instead of calling the API to retrieve user of this new restaurant
                     * just dress the object here and return it back to master view
                     */
                    restaurant.user = { email };

                    this.reset();

                    if (this.props.onAdded)
                        this.props.onAdded(restaurant);
                }
            });
    }

    render() {
        const { classes } = this.props;

        return (
            <Modal
                open={this.props.open}
                onClose={this.props.onClose}
            >
                <div className={classes.paper}>
                    <Grid container spacing={24}>
                        <Grid item xs={12}>
                            <Typography variant="title">{this.props.t('Lisää toimipaikka')}</Typography>
                        </Grid>

                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                label={this.props.t('Toimipaikan nimi')}
                                value={this.state.name}
                                onChange={(event) => this.setState({name: event.target.value})}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                label={this.props.t('Sähköposti')}
                                value={this.state.email}
                                onChange={(event) => this.setState({email: event.target.value})}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                type="password"
                                label={this.props.t('Salasana')}
                                value={this.state.password}
                                onChange={(event) => this.setState({password: event.target.value})}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                type="date"
                                label={this.props.t('Kirjausjakson alku')}
                                value={this.state.reporting_period_start}
                                onChange={(event) => this.setState({reporting_period_start: event.target.value})}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                type="date"
                                label={this.props.t('Kirjausjakson päätös')}
                                value={this.state.reporting_period_end}
                                onChange={(event) => this.setState({reporting_period_end: event.target.value})}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <RadioGroup
                                value={this.state.type}
                                onChange={(event) => this.setState({type: event.target.value})}
                            >
                                {Object.keys(RestaurantType).map((key) => {
                                    let typeLabel = RestaurantType[key];
                                    return (
                                        <FormControlLabel key={key} value={key} control={<Radio />} label={this.props.t(typeLabel)} />
                                    );
                                })}
                            </RadioGroup>
                        </Grid>

                        <Grid item xs={12} style={{textAlign: 'right'}}>
                            <Button
                                color="primary"
                                onClick={() => this.add()}
                            >
                                {this.props.t('Lisää')}
                            </Button>
                        </Grid>
                    </Grid>
                </div>
            </Modal>
        );
    }
}

RestaurantAdder.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withTranslation()(withStyles(styles)(RestaurantAdder));



// WEBPACK FOOTER //
// ./resources/assets/js/components/RestaurantAdder.js